import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BreadcrumbService } from '../../../domain/services/breadcrumb/breadcrumb.service';
import { ExemptionType, ExemptionTypesService } from '../../../domain/services/admin/exemption-types.service';

/** Exemption types a return line can claim (portal + cashier dropdowns). Same layout as Jurisdictions. */
@Component({
  selector: 'app-exemption-types',
  standalone: true,
  imports: [CommonModule, FormsModule, MatCardModule, MatButtonModule, MatIconModule, MatProgressBarModule],
  templateUrl: './exemption-types.component.html',
  styleUrl: '../jurisdictions/jurisdictions.component.css',
})
export class ExemptionTypesComponent implements OnInit {
  types: ExemptionType[] = [];
  loading = false;
  busy = false;
  error: string | null = null;
  savedId: number | null = null;
  newName = '';
  newDescription = '';

  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    private readonly service: ExemptionTypesService,
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.updateBreadcrumbs([
      { icon: 'rule', url: '/app/admin/exemption-types', label: 'Administrative' },
      { icon: 'rule', url: '/app/admin/exemption-types', label: 'Exemption types' },
    ]);
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = null;
    this.service.getAll().subscribe({
      next: (list) => { this.types = list; this.loading = false; },
      error: () => { this.error = 'Failed to load exemption types.'; this.loading = false; },
    });
  }

  add(): void {
    const name = this.newName.trim();
    if (!name) return;
    this.busy = true;
    this.error = null;
    const sortOrder = Math.max(0, ...this.types.filter(t => t.sortOrder < 99).map(t => t.sortOrder)) + 1;
    this.service.create({ name, description: this.newDescription.trim() || null, active: true, sortOrder }).subscribe({
      next: () => { this.busy = false; this.newName = ''; this.newDescription = ''; this.load(); },
      error: (e) => { this.busy = false; this.error = e?.error?.message || 'Failed to add exemption type.'; },
    });
  }

  save(t: ExemptionType): void {
    if (!t.id || !t.name?.trim()) return;
    this.busy = true;
    this.error = null;
    this.service.update(t.id, t).subscribe({
      next: () => {
        this.busy = false;
        this.savedId = t.id!;
        setTimeout(() => { if (this.savedId === t.id) { this.savedId = null; } }, 2000);
      },
      error: () => { this.busy = false; this.error = 'Failed to save exemption type.'; },
    });
  }
}
